<template>
  <div class="transcription-modal-wrap">
    <woot-modal
      :show="show"
      :on-close="onClose"
      content-class="transcription-modal-container"
    >
      <div class="transcription-modal">
        <woot-modal-header
          :header-title="$t('CONVERSATION.CONTEXT_MENU.SHOW_TRANSCRIPTION')"
        />
        <div v-if="loading" class="transcription-modal__state">
          <spinner />
          <p>{{ $t('CONVERSATION.CONTEXT_MENU.TRANSCRIPTION_LOADING') }}</p>
        </div>
        <div v-else class="transcription-modal__body">
          <p class="transcription-modal__text">{{ transcription }}</p>
        </div>
      </div>
    </woot-modal>
  </div>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    transcription: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.transcription-modal-wrap {
  :deep(.modal-container.transcription-modal-container) {
    border-radius: 16px;
    overflow: hidden;
  }
}

.transcription-modal {
  @apply flex flex-col max-h-[70vh];
}

.transcription-modal__state {
  @apply flex flex-col items-center justify-center gap-3 py-10 text-slate-600 dark:text-slate-300;
}

.transcription-modal__body {
  @apply overflow-y-auto px-8 pb-8;
}

.transcription-modal__text {
  @apply m-0 rounded-xl bg-slate-50 dark:bg-slate-800 p-4 text-sm leading-6 text-slate-700 dark:text-slate-200 whitespace-pre-wrap;
}
</style>
